// extracted by mini-css-extract-plugin
module.exports = {"menuGroup":"MenuGroup_menuGroup__Yu2gk","menuItem":"MenuGroup_menuItem__cvftq"};